module.exports = __webpack_public_path__ + "img/product-banner4.ebe1b26e.jpg";